import { Button, Skeleton, Text } from '@chakra-ui/react';
import { useLogin } from '@acp/feature/auth';
import { StateId } from '@acp/shared';
import { useSearchParams } from 'react-router-dom';

export function LoginStateButton({
    complianceStateId,
    stateShortName,
}: {
    complianceStateId: number;
    stateShortName: string;
}) {
    const [searchParams] = useSearchParams();
    const { isLoggingIn, login } = useLogin({
        stateId: complianceStateId as StateId,
        stateParameter: searchParams.get('redirect'),
        onLogin: (url) => {
            window.location.assign(url);
        },
    });

    return (
        <Button
            onClick={login}
            py={{ base: 8, sm: 12, md: 14 }}
            isLoading={isLoggingIn}
            loadingText="Please wait"
            colorScheme="primary"
        >
            <Text noOfLines={1}>
                {stateShortName}
            </Text>
        </Button>
    );
}

function LoginStateButtonSkeleton() {
    return (
        <Skeleton>
            <Button py={{ base: 8, sm: 12, md: 14 }} isLoading>
                <Text noOfLines={1}>
                    Loading
                </Text>
            </Button>
        </Skeleton>
    );
}

LoginStateButton.Skeleton = LoginStateButtonSkeleton;
